// extracted by mini-css-extract-plugin
export default {"failGif":"CredentialsExpiredModal_failGif__510Q0"};